import { connect } from 'react-redux';

import { homeActions } from 'dataflow/distributorPortal/actions';

import { HomePresentation } from './HomePresentation';

function mapStateToProps(state) {
    const { 
        getOneClickActionDetails_requesting, oneClickActionDetails,
        getCompanyDetails_requesting, companyDetails, companyDetailsHeaders 
    } = state.distributorPortal_homeReducers;

	return {
        getOneClickActionDetails_requesting,
        oneClickActionDetails,

        getCompanyDetails_requesting,
        companyDetails,
        companyDetailsHeaders
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getOneClickActionDetails: () => { dispatch(homeActions.getOneClickActionDetails()); },
        getTableDetails: (pageNo, pageSize, sort, filterOptions) => { dispatch(homeActions.getCompanyDetails(pageNo, pageSize, sort, filterOptions)); },
    };
}

const Home = connect(mapStateToProps, mapDispatchToProps)(HomePresentation);

export default Home;